import jump from 'jump.js';
import BasePage from '../../components/base-page/base-page';

import './policy.scss';

/*
* Height of header in pixels
* Should prevent content area overlapped by header when using jump
* And for proper calculating of adding active class to navigation links
* */
const HEADER_HEIGHT = 80;

class PrivacyPolicyPage extends BasePage {
  uiCollections = {
    navLinks: '.policy-nav__item',
  };

  events = {
    'click @uiCollections.navLinks': 'handleNavLinkClick',
  };

  onInit() {
    super.onInit();

    this.initNavLinksScrollListener(this.uiCollections.navLinks);
  }

  initNavLinksScrollListener(navLinks) {
    document.addEventListener('scroll', () => {
      this.handlePageScroll(navLinks);
    });
  }

  handlePageScroll(navLinks) {
    navLinks.forEach((navLink) => {
      const reference = navLink.getAttribute('href');
      const referenceElement = this.rootElement.querySelector(reference);
      const referenceElementPosition = referenceElement.getBoundingClientRect();

      if (referenceElementPosition.top <= HEADER_HEIGHT && referenceElementPosition.bottom >= HEADER_HEIGHT) {
        this.uiCollections.navLinks.forEach((link) => {
          link.classList.remove('policy-nav__item_active');
        });
        navLink.classList.add('policy-nav__item_active');
      } else {
        navLink.classList.remove('policy-nav__item_active');
      }
    });
  }

  handleNavLinkClick(e) {
    e.preventDefault();

    jump(e.target.hash, { offset: -(HEADER_HEIGHT) });
  }
}

export default PrivacyPolicyPage;

PrivacyPolicyPage.initOnDomLoaded();
